import type { ValidationResult } from './types';

export const formatValidationResponse = (valid: boolean, message: string): ValidationResult => {
  return valid ? { valid } : { valid, message };
};
